import http from '@util/http';
import { finance } from '@api/req';

/**
 * 报销
 */
export async function queryRecoupList(params) {
  return http.get(finance.GET_RECOUP_LIST, params);
}

export async function queryRecoupMyList(params) {
  return http.get(finance.GET_RECOUP_MY, params);
}

export async function queryMyRecoupCheckList(params) {
  return http.get(finance.GET_RECOUP_CHECK, params);
}

export async function queryRecoupOrgStatic(params) {
  return http.get(finance.GET_RECOUP_STATIC_ORG, params);
}

export async function queryRecoupIncubatorStatic(params) {
  return http.get(finance.GET_RECOUP_STATIC_INCUBATOR, params);
}

export async function queryRecoupOrgRecord(params) {
  return http.get(finance.GET_RECOUP_RECORD_ORG, params);
}

export async function queryRecoupInfo(params) {
  return http.get(finance.GET_RECOUP_INFO, params);
}

export async function querySaveRecoup(params) {
  return http.post(finance.RECOUP_SAVE, params);
}

export async function queryDeleteRecoup(params) {
  return http.get(finance.RECOUP_DELETE, params);
}

export async function queryNextRecoup(params) {
  return http.get(finance.RECOUP_NEXT, params);
}

export async function queryReturnRecoup(params) {
  return http.post(finance.RECOUP_RETURN, params);
}

export async function queryCallbackRecoup(params) {
  return http.get(finance.RECOUP_CALLBACK, params);
}

export async function queryRecoupWorkflow(params) {
  return http.get(finance.RECOUP_WORKFLOW, params);
}



// WEBPACK FOOTER //
// ./src/api/finance/recoup.js